import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { Template } from '../../common/Template'
import { InvestorSummarySection } from './InvestorSummarySection'
import { InvestorSummary, InvestorTabType } from '../../../types'
import { InvestorTabGroup } from './InvestorTabGroup'
import { InvestorHead } from '../../common/Head'
import { A } from '../../atoms/A'

type Props = {
  summary: InvestorSummary
  tab: InvestorTabType | null
  className?: string
  children: React.ReactNode
}

export const InvestorTemplate: React.FC<Props> = (props) => {
  return (
    <Template>
      <InvestorHead investor={props.summary} />
      <InvestorSummarySection summary={props.summary} />
      <InvestorTabGroup summary={props.summary} activeTab={props.tab} />
      <div
        css={css`
          background-color: ${colors.gray40};
          padding-bottom: 55px;
        `}
      >
        <div
          css={css`
            max-width: 1200px;
            margin: 0 auto;
          `}
          className={props.className}
        >
          {props.children}
          {props.summary.crunchbaseUrl && (
            <div
              css={css`
                font-size: 12px;
                margin-top: 40px;
                line-height: 1.5;
              `}
              className="powered-by"
            >
              本ページの情報の一部は
              <A
                decoration={'none'}
                href={props.summary.crunchbaseUrl}
                target="_blank"
              >
                Crunchbase
              </A>
              から提供を受けています。
            </div>
          )}
        </div>
      </div>
    </Template>
  )
}
